// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { secondaryNavigationStyles } from "@turnerBlueprint/Overrides/Widgets/Header/SecondaryNavigation";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

secondaryNavigationStyles.linkList = {
    css: css`
        .links-wrapper.horizontal {
            gap: 32px;

            ${StyledButton} {
                ${IconWrapper} {
                    opacity: 0.5;
                    margin-right: 8px;
                    margin-bottom: 1px;
                    &,
                    & > svg {
                        height: auto;
                        width: 10px;
                    }
                }

                ${TypographyStyle} {
                    font-size: 14px;
                    line-height: 22px;
                    font-weight: ${fontConfig.weight.bold};
                    text-transform: none;
                }

                &:hover {
                    ${IconWrapper} {
                        opacity: 0.66;
                    }
                    ${TypographyStyle} {
                        color: ${color("common.ui9")};
                    }
                }
            }
        }
    `,
};
